import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import {
  BreadcrumbProgressModule,
  LibModuleModule
} from '@tmhcc-ng-lib/framwork/breadcrumb-progress';
import { PageStepNavComponent } from './page-step-nav.component';

@NgModule({
  declarations: [PageStepNavComponent],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    LibModuleModule,
    BreadcrumbProgressModule
  ],
  exports: [PageStepNavComponent]
})
export class PageStepNavModule {}
